module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isDisabled,
      "multiple": _vm.isMultiple
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('option', [_vm._v("\n    " + _vm._s(item) + "\n  ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bd9021c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VASelect.vue
// module id = 503
// module chunks = 1